import React from 'react';

import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ModuleHeader, ModuleHeaderSize } from '@/components/ModuleHeader';
import { ModuleProductsSkeleton } from '@/components/ModuleProductsSkeleton';

export function YouMightAlsoLikePlaceholder() {
  const t = useTranslations('common');
  return (
    <section>
      <ModuleHeader
        title={t('YouMightAlsoLike')}
        size={ModuleHeaderSize.Small}
      />
      <ModuleProductsSkeleton
        itemsPerRow={6}
        productsCount={24}
        className={styles.scrollableItemRow}
        attributesClassName={styles.attributesSkeleton}
        minItemWidth={144}
      />
    </section>
  );
}
